<p *ngIf="mapZoom" style="text-align: left;">Zoom Level: {{mapZoom}}</p>
<div class="map-container" #mapContainer></div>
